module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"functionList":"Function list"},"fr":{"functionList":"Liste des fonctions"}}')
  delete Component.options._Ctor
}
